var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',{staticStyle:{"flex":"0 0 auto"}},[_c('AppView')],1),_c('Snackbar',{attrs:{"value":_vm.snackbar,"text":_vm.snackbar_text,"type":_vm.snackbar_type},on:{"closed":function($event){_vm.snackbar = false}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }